import { useContext } from 'react';
import type { LocaleContextValue } from './context';
import { LocaleContext } from './context';

export function useLocale(): LocaleContextValue {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
}

